<section class="as-font">
  <div class="as-row as-justify-end as-font">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>
  <mat-label class="as-title-responsive as-roboto-slab as-font-bold as-font-24">
    {{ "ACCESSIBILITY.preferences" | translate }}
  </mat-label>

  <span class="as-font-12 as-font-black-gray">{{
    "ACCESSIBILITY.service" | translate
  }}</span>
  <form
    autocomplete="off"
    class="as-accessibility-container"
    [formGroup]="preferencesForm"
    >
    @for (preference of preferences; track preference) {
      <div class="as-title-container">
        <mat-label class="as-subtitle-responsive as-font-14 as-font-semibold">
          {{ preference.message | translate }}
        </mat-label>
        <mat-slide-toggle
          class="as-slide-toggle"
          formControlName="{{ preference.control }}"
          [checked]="preference.value"
          >
        </mat-slide-toggle>
      </div>
    }

    <mat-label class="as-sub-title as-font-14">
      {{ "ACCESSIBILITY.description" | translate }}
    </mat-label>
    <mat-form-field
      class="as-text-area as-font"
      appearance="outline"
      color="accent"
      >
      <textarea
        autosize
        matInput
        formControlName="extra_info"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="8"
      ></textarea>
    </mat-form-field>

    <div class="as-action-button as-font">
      <button
        type="button"
        class="as-button-action-cancel"
        mat-flat-button
        mat-dialog-close
        >
        {{ "GENERAL.cancel" | translate }}
      </button>
      <button
        mat-flat-button
        color="accent"
        (click)="updateAccessibility()"
        [disabled]="!preferencesForm.valid"
        >
        <mat-label class="as-font-white">
          {{ "GENERAL.update" | translate }}
        </mat-label>
      </button>
    </div>
  </form>
</section>
